import { render } from "./Continue.vue?vue&type=template&id=305fadd4&bindings={\"showPageError\":\"data\",\"hasCodeFromParams\":\"data\",\"isMounting\":\"data\",\"isLoading\":\"data\",\"code\":\"data\",\"hideLoading\":\"options\",\"loadApplication\":\"options\",\"onSubmit\":\"options\",\"validator\":\"options\"}"
import script from "./Continue.vue?vue&type=script&lang=js"
export * from "./Continue.vue?vue&type=script&lang=js"
script.render = render

export default script